/**
 * Rótulo do eixo X do gráfico "Coletas recorrentes x solicitadas sob demanda":
 * `2026-05-01` → `Maio/26` (Figma node 345:16164).
 *
 * A data é parseada como string, não via `new Date('2026-05-01')` — aquilo é
 * interpretado como meia-noite **UTC** e, no fuso de Brasília, volta como o
 * último dia do mês anterior. `Maio/26` viraria `Abril/26`.
 */
const MONTH_NAMES = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

/** `2026-05-01` → `Maio/26`. Entrada inválida volta como veio. */
export function formatMonthLabel(month: string): string {
  const match = /^(\d{4})-(\d{2})/.exec(month);
  if (!match) return month;

  const name = MONTH_NAMES[Number(match[2]) - 1];
  if (!name) return month;

  return `${name}/${match[1].slice(2)}`;
}

/** `2026-05-01` → `Maio de 2026`. Versão longa, para o tooltip. */
export function formatMonthLong(month: string): string {
  const match = /^(\d{4})-(\d{2})/.exec(month);
  if (!match) return month;

  const name = MONTH_NAMES[Number(match[2]) - 1];
  if (!name) return month;

  return `${name} de ${match[1]}`;
}
